// extracted by mini-css-extract-plugin
export default {"reCaptchaContainer":"cL_kQ"};